<template>
<div class="schedule-select" v-if="disable">
    <el-time-select :picker-options="{start: '00:00',step: '00:15',end: '23:45'}" v-model="time" placeholder="select" :clearable="false" :editable="false"></el-time-select>
    <div style="margin-top:10px;">
        <div @mouseenter="hoverIndex=index" @mouseleave="hoverIndex=-1" @click="checkMonthDay(item)" :class="[index==31?'month-last-box':'',monthArr.includes(item)&&disable?'click-monthday-box-disable':'',monthArr.includes(item)&&!disable?'click-monthday-box':'',hoverIndex==index?'monthday-box-hover':'',monthlyDisable?'monthday-box-disable':'monthday-box']" v-for="(item, index) in monthlyData" :key="index">
            <div v-if="item!=0" :class="shakeBox">{{item}}</div>
            <div v-if="item==0" :class="shakeBox">{{$t('language.popup.lastDay')}}</div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['disable'],
    components: {
    },
    data: function () {
        return {
            monthlyData: [],//月日期
            monthArr: [],//选中的日期集合
            time: new Date(),//选中时间集合
            hoverIndex: -1,
            monthlyDisable: false,
            shakeBox: ''
        };
    },
    created() {
        for (let i = 1; i <= 31; i++) {
            this.monthlyData.push(i);
            if (i == 31) {
                this.monthlyData.push(0);
            }
        }
    },
    methods: {
        // 每15分钟向上取整
        getNextQuarterHour() {
            let now = new Date();
            let minutes = now.getMinutes();
            let diffMinutes = Math.ceil(minutes / 15) * 15 - minutes;
            now.setMinutes(now.getMinutes() + diffMinutes);
            if (now.getMinutes() === 60) {
                now.setMinutes(0);
                now.setHours(now.getHours() + 1);
            }
            return now;
        },
        //初始化日期
        initDate(schedules) {
            if(schedules&&schedules.days) {
                this.monthArr = this.judgeShowMonthPage(schedules.days);
                this.time = schedules.times[0];
            }else {
                this.monthArr = [];

                let nowDate = this.getNextQuarterHour();
                let h = nowDate.getHours();
                if (h < 10) {
                    h = '0' + h;
                }
                let m = nowDate.getMinutes();
                if (m < 10) {
                    m = '0' + m;
                }
                this.time = h+":"+m;
            }
        },
        //选中日期
        checkMonthDay(item) {
            if (this.monthArr.includes(item)) {
                this.monthArr = this.monthArr.filter(function (ele) {
                    return ele != item;
                });
            } else {
                if (item != this.$t('language.popup.lastDay')) {
                    this.monthArr.push(item);
                } else {
                    this.monthArr.push(0); //传入最后一天
                }
            }
        },
        //判断是否显示按月界面
        judgeShowMonthPage(days) {
            let daysArr = [];
            $.each(days, function(i, item) {
                if (typeof(item) == 'string') {
                    item = parseInt(item.replace(/\"/g, ""));
                }
                if (item||item==0) {
                    daysArr.push(item);
                }
            });
            return daysArr;
        },
        //获取当前选中日期
        getRunTime() {
            if(this.monthArr.length>0&&this.time) {
                let that = this;
                let days = [];
                $.each(this.monthArr, function (dayIndex, dayItem) {
                    dayItem = parseInt(dayItem);
                    if (dayItem != null && dayItem != undefined && dayItem != "" && !window.isNaN(dayItem)) {
                        days.push(dayItem);
                    }
                    if (dayItem == 0) {
                        days.push(dayItem);
                    }
                });

                days.sort((a, b) => a - b);

                var schedules = {
                    type: 'Monthly',
                    days: Object.assign([], days),
                    times: [that.time],
                }
    
                return schedules;
            }
        }
    }
};
</script>

<style scoped>
.monthly {
    width: 500px;
    /*no*/
    height: 190px;
    /*no*/
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
}

.monthly-left {
    height: 32px;
    /*no*/
    line-height: 30px;
    /*no*/
    float: left;
}

.monthly-title {
    float: left;
}

.monthly-right {
    width: 260px;
    /*no*/
    height: 190px;
    /*no*/
    margin-left: 40px;
    /*no*/
    float: left;
}

.monthday-box {
    width: 52px;
    /*no*/
    height: 30px;
    /*no*/
    border: 1px solid #cdddf5;
    /*no*/
    text-align: center;
    line-height: 30px;
    /*no*/
    float: left;
    margin-right: -1px;
    /*no*/
    margin-bottom: -1px;
    /*no*/
    cursor: pointer;
}

.monthday-box-disable {
    width: 30px;
    /*no*/
    height: 30px;
    /*no*/
    text-align: center;
    line-height: 30px;
    /*no*/
    float: left;
    pointer-events: none;
}

.month-last-box {
    width: 214px;
    /*no*/
    height: 30px;
    /*no*/
    float: left;
    margin: 0;
}

.monthday-box-hover {
    background: #5562B4;
    color: #fff;
}

.click-monthday-box {
    background: #7987E2;
    color: #fff;
}

.click-monthday-box-disable {
    background: #5562B4;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_schedule/tab_monthly.vue